import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Percent, Plus, Trash2 } from "lucide-react";

// Liste des taux de TVA du restaurant : paramétrage, jamais une décision fiscale automatique.
export default function VatRatesSettings({ slug }) {
  const [rates, setRates] = useState([]);
  const [configured, setConfigured] = useState(false);
  const [saving, setSaving] = useState(false);
  useEffect(() => { api.vatRates(slug).then((r) => { setRates(r.rates || []); setConfigured(!!r.configured); }).catch(() => {}); }, [slug]);
  const upd = (i, k, v) => setRates((rs) => rs.map((r, j) => (j === i ? { ...r, [k]: v } : r)));
  const save = async () => {
    setSaving(true);
    try {
      const r = await api.setVatRates(slug, rates.map((x) => ({ rate: parseFloat(String(x.rate).replace(",", ".")), label: x.label })));
      setRates(r.rates); setConfigured(true);
      toast.success("Taux de TVA enregistrés (modification tracée)");
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); } finally { setSaving(false); }
  };
  return (
    <div className="rounded-2xl bg-[#111F1A] border border-[#1B3028] p-5 space-y-3" data-testid="vat-settings">
      <h3 className="font-serif-display text-lg flex items-center gap-2"><Percent className="w-4 h-4 text-[#C69C4A]" /> Taux de TVA</h3>
      <p className="text-xs text-stone-400">Liste des taux proposés lors de l'affectation d'un taux à chaque produit (gestion du menu). {configured ? "Liste validée par le restaurant." : <span className="text-amber-400">Liste par défaut proposée — à valider par le restaurant ou son comptable.</span>} Toute modification est journalisée et n'affecte jamais les ventes déjà enregistrées.</p>
      <div className="space-y-2">
        {rates.map((r, i) => (
          <div key={i} className="flex items-center gap-2" data-testid={`vat-rate-row-${i}`}>
            <Input data-testid={`vat-rate-value-${i}`} value={r.rate} onChange={(e) => upd(i, "rate", e.target.value)} className="w-20 bg-[#0A1712] border-[#1B3028] text-stone-100 rounded-xl h-9" />
            <span className="text-stone-500 text-sm">%</span>
            <Input data-testid={`vat-rate-label-${i}`} value={r.label} onChange={(e) => upd(i, "label", e.target.value)} className="flex-1 bg-[#0A1712] border-[#1B3028] text-stone-100 rounded-xl h-9" />
            <button data-testid={`vat-rate-delete-${i}`} onClick={() => setRates((rs) => rs.filter((_, j) => j !== i))} className="text-stone-500 hover:text-red-400 p-1"><Trash2 className="w-4 h-4" /></button>
          </div>
        ))}
      </div>
      <div className="flex gap-2">
        <Button data-testid="vat-rate-add" variant="outline" onClick={() => setRates((rs) => [...rs, { rate: "", label: "" }])} className="rounded-full bg-transparent border-[#1B3028] text-stone-300"><Plus className="w-4 h-4 mr-1" /> Ajouter un taux</Button>
        <Button data-testid="vat-rates-save" onClick={save} disabled={saving} className="rounded-full bg-[#C69C4A] text-[#0C1713] hover:bg-[#B38B3A] font-bold">{saving ? "..." : "Enregistrer"}</Button>
      </div>
    </div>
  );
}
